import { all, fork } from "redux-saga/effects";
import { authWatcher } from "../sagas/auth";
import { locationWatcher } from "../sagas/location";
import { invoiceWatcher } from "../sagas/invoice";
export default function* () {
  yield all([fork(authWatcher), fork(locationWatcher), fork(invoiceWatcher)]);
}

export function handleErrors(error) {
  if (error.response && error.response.status === 404) {
    return "Something went wrong";
  }

  if (error.response) {
    /*
     * The request was made and the server responded with a
     * status code that falls out of the range of 2xx
     */
    return error.response.data.message || error.response.data.error;
  }
  if (error.request) {
    /*
     * The request was made but no response was received, `error.request`
     * is an instance of XMLHttpRequest in the browser and an instance
     * of http.ClientRequest in Node.js
     */
    return "Something went wrong.";
  }
  // Something happened in setting up the request and triggered an Error
  return error.message;
}
